import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-border/40 bg-secondary/30">
      <div className="container mx-auto px-4 lg:px-6 max-w-7xl py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <a href="#accueil" className="inline-block mb-4">
              <img
                src="/logos/logo-header-light.svg"
                alt="Medina Fidélité"
                className="h-[50px] dark:hidden"
              />
              <img
                src="/logos/logo-header-dark.svg"
                alt="Medina Fidélité"
                className="h-[50px] hidden dark:block"
              />
            </a>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              Fidélisation numérique pour les commerces de proximité au Maroc.
              Construisez votre communauté, suivez vos visites, lancez vos
              campagnes. Conforme à la loi 09-08, déclaré à la CNDP.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground mb-4 uppercase tracking-wider">
              Produit
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#avantages" className="text-muted-foreground hover:text-primary transition-colors">
                  Avantages
                </a>
              </li>
              <li>
                <a href="#fonctionnement" className="text-muted-foreground hover:text-primary transition-colors">
                  Comment ça marche
                </a>
              </li>
              <li>
                <a href="#inscription" className="text-muted-foreground hover:text-primary transition-colors">
                  Inscrire mon commerce
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground mb-4 uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-muted-foreground">
                <Mail className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <a
                  href="mailto:contact@medinafidelite.ma"
                  className="hover:text-primary transition-colors"
                >
                  contact@medinafidelite.ma
                </a>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <Phone className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <a
                  href="tel:+212708008119"
                  className="hover:text-primary transition-colors"
                >
                  <bdi dir="ltr">+212 7 08 00 81 19</bdi>
                </a>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span>
                  59 Avenue Ibn Sina Appt N11 Agdal
                  <br />
                  Rabat, Maroc
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border/40 flex flex-col sm:flex-row gap-4 items-center justify-between text-xs text-muted-foreground">
          <p>© {year} Medina Fidélité par NeoSolus. Tous droits réservés.</p>
          <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            <a
              href="/confidentialite"
              className="hover:text-primary transition-colors"
            >
              Politique de confidentialité
            </a>
            <span aria-hidden="true">·</span>
            <a
              href="/conditions"
              className="hover:text-primary transition-colors"
            >
              Conditions d'utilisation
            </a>
            <span aria-hidden="true">·</span>
            <span>Déclaration CNDP n° (en cours) · Loi 09-08 sur la protection des données personnelles</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
